import { render } from "./editGarmentManagementModal.vue?vue&type=template&id=45294da8&scoped=true&ts=true"
import script from "./editGarmentManagementModal.vue?vue&type=script&lang=ts"
export * from "./editGarmentManagementModal.vue?vue&type=script&lang=ts"

import "./editGarmentManagementModal.vue?vue&type=style&index=0&id=45294da8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45294da8"]])

export default __exports__